import RequestAbstract from "../abstract";

export default class PublicCountries extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-countries";
    }

}
